import { Box, Grid, Paper, Snackbar, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import { ActionMsg, AddButton, Breadcrumb, CustomePopover, DateConversionOnEntryPage, DeleteDialog, ExcelDownload, HandleCloseSnackbar, HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler } from "../../reusableComponent/Reusables";
import { rows } from './../MastersFakeDb';
import { editDeleteRate, getRateList } from "../../../actions/actions";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";



const RateList = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();
    const [sortBy, setSortBy] = useState(null);
   
    const rows = useSelector(state => state.rate.rate)
    const [searchKey, setSearchKey] = useState('');

    const fields = ['id', "dress_type", "cost"];
    const labels = ['Id', "dress_type", "cost"];

    // const [successMessage, setSuccessMessage] = useState(null);
    // const respMsgState = 'test'
    // // const respMsgState = useSelector((state) => state.rate.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: 10
    });

    const handleChangePage = (event, newPage) => {
        setController({
            ...controller,
            page: newPage
        });
    };

    const handleChangeRowsPerPage = (event) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

    const fetchData = () => {
        const params = {
            page: controller.page,
            size: controller.rowsPerPage,
            searchKey: searchKey,
        }
        dispatch(getRateList(params))
    };

    const handleSearch = (e) => {
        setSearchKey(e.target.value)
        const params = {
            page: controller.page,
            size: e.target.value === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
            searchKey: e.target.value,
        }
        dispatch(getRateList(params))
    }

    useEffect(() => {
        fetchData()
    }, [controller]);

    // const { shouldShowMsg, responseMessage } = useMessageHandler( null, setSuccessMessage, respMsgState);

    // useEffect(() => {
    // }, [shouldShowMsg, responseMessage,]);

    const deleteRecord = (id) => {
        dispatch(editDeleteRate({ rate_id: id, changedUpdatedValue: 'delete' }))
        setIsDelete(false);
        fetchData()
    }

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
    };

     const [successMessage, setSuccessMessage] = useState(null);
            //const respMsgState = 'test'
            const respMsgState = useSelector((state) => state.rate.message);
    
            const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData,null, setSuccessMessage, respMsgState);
                 useEffect(() => {
                        if (respMsgState) {
                            setSuccessMessage(respMsgState);
                        }
                    }, [respMsgState]);
                useEffect(() => {
                }, [shouldShowMsg, responseMessage,]);
    
    return (
        <>
            <Paper className={`${styles.cts_page}`}>
                <Breadcrumb
                    routeSegments={[
                        // { name: 'Dashbord', path: '/dashboard' },
                        { name: 'Rate List' },
                    ]}
                />
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
                        <Grid item md={7} sm={6} xs={12}>
                            <Box sx={{ display: 'flex' }}>
                                <Typography className={`${styles.form_title}`} >
                                    Rate List
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item md={5} sm={6} xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Box className={`${styles.excel_box}`}>
                                <ExcelDownload
                                    data={rows}
                                    fields={fields}
                                    labels={labels}
                                    filename="Rate List"
                                />
                            </Box>
                            <SearchInput
                                value={searchKey}
                                onChange={handleSearch}
                                
                            />
                            <AddButton to="/masters/add-rate" label="" />
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>
                                <StyledTableCell align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('cust_name', sortBy, setSortBy, rows)}>Customer Name<span className={`${styles.sort_icon}`}> {sortBy === 'cust_name' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('prod_code', sortBy, setSortBy, rows)}>Production Code<span className={`${styles.sort_icon}`}> {sortBy === 'prod_code' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('uom', sortBy, setSortBy, rows)}>UOM<span className={`${styles.sort_icon}`}> {sortBy === 'uom' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => HandleSort('uom_rate', sortBy, setSortBy, rows)}>UOM Rate<span className={`${styles.sort_icon}`}> {sortBy === 'uom_rate' ? '▲' : '▼'} </span></StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(rows) && rows.map((row, index) => (
                                <StyledTableRow
                                    key={row.name}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                    <StyledTableCell align="center" >
                                        <CustomePopover row={row} handleDelete={false} linkTo="/masters/add-rate" />
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.cust_name}</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.prod_code}</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.uom}</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.uom_rate}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                      rowsPerPageOptions={[10, 25, 100]}
                      component="div"
                      count={total_count || 0}
                      rowsPerPage={controller.rowsPerPage}
                      page={controller.page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.rate_id || null}
                    displayName={deleteInfo?.rate_id || ''}
                />
                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') {
                            setSuccessMessage("");
                        }
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Paper>
        </>
    )
}
export default RateList;